/*globals debounce*/
(function quickSearch($) {

    // After search results populated:
    var $results = $('#quick-search__results');
    var $scrollIcon = $('.quick-search__scroll-icon', $results);
    var $input = $('#quick-search__query');

    // Auto complete
    var queryURL = 'https://fbwebsite-search.clients.funnelback.com/s/search.json?collection=funnelback-meta&profile=_default&form=popup-overlay&query=';
    var minInputLength = 3;
    var inputDelay = 100;

    function getResultOffset() {
        return $results.height() + $results.offset().top;
    }

    function updateScroll() {
        var isVisible = getResultOffset() > window.pageYOffset;
        if (isVisible) {
            $scrollIcon.removeClass('is-visible');
        } else {
            $scrollIcon.addClass('is-visible');
        }
    }

    $(window).on('scroll.quick-search', updateScroll);

    function clearResponse() {
        $results.empty();
    }

    function displayResponse(response) {
        if (response.resultPacket &&
            response.resultPacket.results.length >= 1) {
            clearResponse();
            var $ul = $('<ul class="quick-search__results-list"></ul>');
            $ul.append($.map(response.resultPacket.results, function(result) {
                var summary = result.summary;
                var title = result.title.replace(/(\s-.+)$/, '');
                if(result.liveUrl.indexOf('docs.funnelback.com') > 0) {
                    title += ' (Funnelback Docs)';
                }
                return $('<li class="quick-search__results-item"><a href="'+result.liveUrl+'"><h2 class="quick-search__results-item-title">'+
                    title+'</h2><div class="quick-search__results-item-detail"><p>'+summary+'</p></div></li>');
            }));
            $ul.appendTo($results);
        }
    }

    $input.on('keyup',
        debounce(function() {
            var val = $input.val();
            if (val.length >= minInputLength) {
                var thisQuery = queryURL + encodeURIComponent(val);
                $.ajax({
                    url:      thisQuery,
                    dataType: 'jsonp'
                })
                .then(function(result) {
                    if (result && result.hasOwnProperty('response')) {
                        displayResponse(result.response);
                    }
                });
            }
        }, inputDelay)
    );

    $(document).keyup(function(e) {
         if (e.keyCode == 27) { // escape key maps to keycode 27
             if($('.quick-search.is-active').length > 0) {
                 $('.quick-search__close').click();
                 clearResponse();
             }
        }
    });

}(jQuery));


(function($){
    'use strict';

    // Re-use accordion expand behavior to control state
    // between the active menu elements
    $('header, #quick-search').UberAccordion({
        buttonClass: 'expand-toggle',
        toggle:      true,
        multiple:    false,

        appliedClasses: {
            activeButton: 'is-active',
            activeTarget: 'is-active'
        },

        onSelect: function($button, $target) {

            // Give the quick search input focus when the overlay is presented
            if ($target.hasClass('quick-search')) {
                $('#quick-search__query').focus();
            }

            if ($button.hasClass('is-active')) {
                $('html').addClass('is-blocked');
                $('body').addClass('is-search-expanded');
                $('.quick-search__close').addClass('is-active');

                // Always scroll top for quick search
                if ($button.attr('id') === 'quick-search__toggle') {
                    $(window).scrollTop(0);
                }
            } else {
                $('html').removeClass('is-blocked');
                $('body').removeClass('is-search-expanded');
                $('#quick-search__toggle').removeClass('is-active');
            }
        }
    });

}(jQuery));
